export const apiConfig = {
    tenantId: '',
    userId: '' ,
    token: ''
  };